import { render, staticRenderFns } from "./gjcr.vue?vue&type=template&id=35c33b32&scoped=true&"
import script from "./gjcr.vue?vue&type=script&lang=js&"
export * from "./gjcr.vue?vue&type=script&lang=js&"
import style0 from "./gjcr.vue?vue&type=style&index=0&id=35c33b32&prod&lang=scss&scoped=true&"
import style1 from "./gjcr.vue?vue&type=style&index=1&id=35c33b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c33b32",
  null
  
)

export default component.exports